import { Button, Form, List, Popup } from "devextreme-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import LoaderPage from "../../../../../layouts/loader-page/loader-page";
import BaseFormWithBreadCrumbs from "../../../../../components/base-form/base-form";
import { GroupItem, Item, RequiredRule } from "devextreme-react/cjs/form";
import { CheckListTemplateDocumentinfoSelect } from "./check-list-template-documentinfo-select.tsx";
import { useParams } from "react-router-dom";

export function CheckListTemplateCard() {

    const formRef = useRef(null)
    const params = useParams()
    //const [templateId, setTemplateId] = useState(params.id)
    const [sending, setSending] = useState(false)
    const [loading, setLoading] = useState(false)
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [id, setId] = useState(params.id)
    const [employeeDocumentInfos, setEmployeeDocumentInfos] = useState([])
    const [popupVisible, setPopupVisible] = useState(false)

    const [formData, setFormData] = useState(
        {
            "name": "",
            "employeeDocumentInfos": [],
            //"id": ""
        }
    )

    const handleSubmit = () => {

    }

    // async function onAfterFetch(data) {
    //     if (data?.employeeDocumentInfos?.length == 0)
    //         return data
    //
    //     var tmpSteps = data.employeeDocumentInfos.sort((a, b) => a.step - b.step)
    //     return {
    //         ...data,
    //         employeeDocumentInfos: tmpSteps
    //     }        
    // }

    const onAfterLoadData = (data) => {
        if (data?.employeeDocumentInfos)
            setEmployeeDocumentInfos(data.employeeDocumentInfos)

    }

    const handleFieldDataChanged = useCallback((e) => {
        setDirty(true)
    }, [setDirty])

    const handleAdd = useCallback(() => {
        setPopupVisible(true)
    }, [])

    const handlePopupHiding = () => {
        setPopupVisible(false)
    }
    const updateFormData = (employeeDocumentInfos) => {
        //console.log("employeeDocumentInfos", employeeDocumentInfos)

        setFormData((prev) => {
            //    console.log("prev",prev)
            return {
                ...prev,
                employeeDocumentInfos: employeeDocumentInfos
            }
        })
        setDirty(true)
    }
    useEffect(() => {
        console.log("kard formdata mdeğişti: ", formData)
    }, [formData])

    const onItemDeleted = () => {
        //console.log("employeeDocumentInfos", employeeDocumentInfos)
        updateFormData(employeeDocumentInfos);
        //setDirty(true)
    }

    return (
        <LoaderPage
            loading={loading}>
            <BaseFormWithBreadCrumbs
                formData={formData}
                setFormData={setFormData}
                formRef={formRef}
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                dirty={dirty}
                setDirty={setDirty}
                loadId={id}
                loadUrl={"/api/EmployeeCheckListTemplate/"}
                updateUrl={"/api/EmployeeCheckListTemplate/FormData"}
                dataLoading={loading}
                setDataLoading={setLoading}
                onAfterLoadData={onAfterLoadData}
                setId={setId}
            //toUpdateValues={employeeDocumentInfos}
            //onAfterSave = {onAfterSave}
            >
                <Form
                    width={600}
                    formData={formData}
                    readOnly={readOnly}
                    onFieldDataChanged={handleFieldDataChanged}
                    ref={formRef}
                >
                    <Item dataField="name">
                        <RequiredRule />
                    </Item>

                    <GroupItem>
                        <div style={{ margin: "10px" }}>
                            <Button text="Ekle" onClick={handleAdd} />
                        </div>
                    </GroupItem>
                </Form>
                <div className="dx-card" style={{ width: "600px" }}>
                    <List
                        dataSource={employeeDocumentInfos}
                        displayExpr="name"
                        keyExpr="id"
                        allowItemDeleting={true}
                        onItemDeleted={onItemDeleted}
                    >
                    </List>
                </div>

                {popupVisible &&
                    <CheckListTemplateDocumentinfoSelect
                        visible={popupVisible}
                        setVisible={setPopupVisible}
                        onHiding={handlePopupHiding}
                        employeeDocumentInfos={employeeDocumentInfos}
                        setEmployeeDocumentInfos={setEmployeeDocumentInfos}
                        updateFormData={updateFormData}

                    />
                }


            </BaseFormWithBreadCrumbs>
        </LoaderPage>
    )
}

function DocumentInfoListPopup({ }) {

}